import * as d3 from 'd3';
import i18n from '@/lang';
import { sortBy } from 'lodash';

const topoTools = {
  DEVICETYPE: {
    AP: 'AP',
    EAP: 'AP',
    EWR: 'WR',
    EHR: 'WR',
    EGW: 'GATEWAY',
    GATEWAY: 'GATEWAY',
    MSW: 'SWITCH',
    SWITCH: 'SWITCH',
    ESW: 'SWITCH',
    AC: 'AC',
    EAC: 'AC',
    FIREWALL: 'FIREWALL',
    UNKNOW: 'UNKNOW',
    ipc: 'ipc',
    nvr: 'nvr',
    OUT: 'OUT',
    IP_Phone: 'IP_PHONE'
  },
  /**
   * 打包设备成组
   * @param {*} topoData
   * @param {*} commonType
   */
  pickDevice(topoData, commonType) {
    const self = this;
    if (self.checkGroupDevice(topoData.data.children || [], commonType)) {
      self.groupDevice(topoData, commonType);
    }
  },
  /**
   * 打包设备成组
   * @param {*} topoData
   * @param {*} commonType
   */
  rootPickDevice(topoData, commonType) {
    const self = this;
    if (self.checkGroupDevice(topoData.children || [], commonType)) {
      self.rootGroupDevice(topoData, commonType);
    }
  },
  /**
   * 检测子分组指定设备是否大于1台
   * @param {*} deviceList
   * @param {*} commonType
   * @returns
   */
  checkGroupDevice(deviceList, commonType) {
    const self = this;
    let list = [];
    for (let i = 0; i < deviceList.length; i++) {
      if (self.DEVICETYPE[deviceList[i].deviceType] == commonType) {
        list.push(deviceList[i]);
      }
    }
    return list.length > 1;
  },
  /**
   * 将设备打包
   * @param {*} topoData
   * @param {*} commonType
   */
  groupDevice(topoData, commonType) {
    const self = this;
    let deviceList = [],
      parentPortList = [],
      uplinkPortList = [];
    let groupStatus = 'ON';
    topoData.data.children = topoData.data.children.filter(function (item) {
      if (self.DEVICETYPE[item.deviceType] == commonType) {
        parentPortList.push(item.parentPort);
        uplinkPortList.push(item.uplinkPort);
        deviceList.push(item);
        if (item.onlineStatus != 'ON') {
          groupStatus = 'OFF';
        }
        return false;
      } else {
        return true;
      }
    });
    topoData.children = topoData.children.filter(item => !(self.DEVICETYPE[item.data.deviceType] == commonType));

    topoData.data[`${commonType.toLocaleUpperCase()}_ChildList`] = deviceList;
    let timer = new Date().getTime();

    let name = commonType.toLocaleUpperCase() == 'IPC' ? i18n.t('common.camera') : 'AP';
    let groupDevice = {
      name: `${name}${i18n.t('topo.group')}`,
      deviceType: `${commonType.toLocaleUpperCase()}_GROUP`,
      id: timer,
      deviceSn: `${commonType.toLocaleUpperCase()}_GROUP_${timer}_${Math.floor(Math.random() * 100)}`,
      parentPort: self.formatterAlias(parentPortList),
      uplinkPort: Array.from(new Set(uplinkPortList)).join(),
      onlineStatus: groupStatus,
      _children: deviceList,
      children: []
    };
    let newNode = d3.hierarchy(groupDevice);
    newNode.depth = topoData.depth + 1;
    newNode.height = topoData.height - 1;
    newNode.parent = topoData;
    //groupDevice[`group_${commonType.toLocaleUpperCase()}`] = deviceList
    topoData.children.push(newNode);
    topoData.data.children.push(newNode.data);
  },
  /**
   * 将设备打包
   * @param {*} topoData
   * @param {*} commonType
   */
  rootGroupDevice(topoData, commonType) {
    const self = this;
    let deviceList = [],
      parentPortList = [],
      uplinkPortList = [];
    let groupStatus = 'ON';
    topoData.children = topoData.children.filter(function (item) {
      if (self.DEVICETYPE[item.deviceType] == commonType) {
        parentPortList.push(item.parentPort);
        uplinkPortList.push(item.uplinkPort);
        deviceList.push(item);
        if (item.onlineStatus != 'ON') {
          groupStatus = 'OFF';
        }
        return false;
      } else {
        return true;
      }
    });
    topoData[`${commonType.toLocaleUpperCase()}_ChildList`] = deviceList;
    let timer = new Date().getTime();
    let name = commonType.toLocaleUpperCase() == 'IPC' ? i18n.t('common.camera') : 'AP';
    let groupDevice = {
      name: `${name}${i18n.t('topo.group')}`,
      deviceType: `${commonType.toLocaleUpperCase()}_GROUP`,
      id: timer,
      deviceSn: `${commonType.toLocaleUpperCase()}_GROUP_${timer}_${Math.floor(Math.random() * 100)}`,
      parentPort: self.formatterAlias(parentPortList),
      uplinkPort: Array.from(new Set(uplinkPortList)).join(),
      onlineStatus: groupStatus,
      _children: deviceList,
      children: []
    };
    topoData.children.push(groupDevice);
  },
  /**
   * 格式化端口名称
   * @param {*} alias
   */
  formatterAlias(alias) {
    const self = this;
    let aliasArray = alias.concat([]);
    //去重
    const aliasNameArr = [...new Set(aliasArray)];
    //判断是否只有一个别名
    if (aliasNameArr.length == 1) {
      return aliasNameArr[0];
    }

    //别名排序
    aliasArray.sort(function (a, b) {
      let as = a.match(/\d+$/g);
      let bs = b.match(/\d+$/g);
      if (as && bs) {
        return as[0] - bs[0];
      } else {
        return -1;
      }
    });
    //定义前缀数组
    let aliasPrefix = {};
    for (let i = 0; i < aliasArray.length; i++) {
      let aliasItem = aliasArray[i];
      let num = aliasItem.match(/\d+$/g) && aliasItem.match(/\d+$/g)[0];
      let prefix = aliasItem.replace(/\d+$/, '');
      if (aliasPrefix[prefix]) {
        aliasPrefix[prefix].push(parseInt(num));
      } else {
        aliasPrefix[prefix] = [];
        aliasPrefix[prefix].push(parseInt(num));
      }
    }

    console.log('前缀排序对象', aliasPrefix);

    let str = '';
    for (let name in aliasPrefix) {
      let aliasString = self.aliasFormat(name, aliasPrefix[name]);
      str += aliasString + ',';
    }

    return str.slice(0, str.length - 1);
  },
  /**
   * 同前缀别名格式化
   * @param {*} prefix
   * @param {*} numArray
   */
  aliasFormat(prefix, numArray) {
    let newList = '';
    let max = numArray[0],
      min = numArray[0];
    for (let i = 0; i < numArray.length; i++) {
      let j = i + 1;
      if (j >= numArray.length) j = i; //注意：因为j=i+1,所以j会出现超出数组下标范围的情况
      //先比较第一个和第二个，如果连续，再比较第二个和第三个...直到出现不连续时就输出缩写1-3，再进行下面数字的比较
      if (numArray[i] == numArray[j] - 1) {
        //如果连续，就先暂时把Arr[j]赋值给-右侧的数字
        max = numArray[j];
      } else {
        if (i == numArray.length - 1) {
          //如果没有这个判断最后会输出newlist="1-3,7-7,10-15,"会多一个‘，’
          if (min == max) {
            newList += prefix + min;
          } else {
            newList += prefix + min + '-' + max;
          }
        } else {
          if (min == max) {
            newList += prefix + min + ',';
          } else {
            newList += prefix + min + '-' + max + ',';
          }
        }
        //此时将min和max都赋值为7
        if (j < numArray.length) {
          min = numArray[j];
          max = numArray[j];
        }
      }
    }

    return newList;
  },
  /**
   * 获取设备图片
   * @param {*} info 设备类型对象
   * @param {*} ports 端口数量
   * @param {*} terminalTypeMap 终端MAP
   * @param {*} onlineStatusFlag 在线状态
   */
  getDevicePanelBgImg(info, terminalTypeMap, onlineStatusFlag) {
    let bgImg = '';
    let onlineStatus = onlineStatusFlag ? onlineStatusFlag : '';
    switch (info.commonType) {
      case 'SWITCH':
        bgImg = `SW${onlineStatus}`;
        break;
      case 'WR':
        bgImg = `GW${onlineStatus}`;
        break;
      case 'GATEWAY':
        bgImg = `GW${onlineStatus}`;
        break;
      case 'FIREWALL':
        bgImg = `GW${onlineStatus}`;
        break;
      case 'AC':
        bgImg = `GW${onlineStatus}`;
        break;
      case 'IP_PHONE':
        bgImg = `tel`;
        break;
      case 'AP': {
        let rapArr = ['RAP220(V2)', 'RAP220(EV2)', 'RAP230', 'Lysora-RAP220(V2)', 'Lysora-RAP220(EV2)', 'Lysora-RAP230'];
        let RG_rap210Arr = [
          'RAP210',
          'RAP210(B)',
          'RAP210(V2)',
          'RAP210(EV2)',
          'Lysora-RAP210',
          'Lysora-RAP210(B)',
          'Lysora-RAP210(V2)',
          'Lysora-RAP210(EV2)'
        ];
        let eapArr = ['EAP201', 'EAP202'];
        let RG_rapArr = [
          'RAP120(V2)',
          'RAP100',
          'RAP110',
          'RAP102',
          'Lysora-RAP120(V2)',
          'Lysora-RAP100',
          'Lysora-RAP110',
          'Lysora-RAP102'
        ];
        let RG_eap = ['EAP101', 'EAP102', 'Lysora-EAP101', 'Lysora-EAP102'];
        if (rapArr.indexOf(info.productClass) != -1) {
          bgImg = 'RAP';
        } else if (RG_rap210Arr.indexOf(info.productClass) != -1) {
          bgImg = 'Lysora-RAP210';
        } else if (eapArr.indexOf(info.productClass) != -1) {
          bgImg = 'EAP';
        } else if (RG_rapArr.indexOf(info.productClass) != -1) {
          bgImg = 'Lysora-RAP';
        } else if (RG_eap.indexOf(info.productClass) != -1) {
          bgImg = 'Lysora-EAP';
        } else if (info.productClass == 'Lysora-RAP602' || info.productClass == 'RAP602') {
          bgImg = 'Lysora-RAP210';
        } else {
          bgImg = 'APcommon';
        }
        break;
      }
      case 'nvr':
        bgImg = `GW${onlineStatus}`;
        break;
      default: {
        let commontype = info.commonType == 'ipc' ? 'camera' : info.commonType;
        commontype = commontype || info.deviceType;
        if (commontype == 'camera') {
          bgImg = `IPC${onlineStatus}`;
        } else if (terminalTypeMap[commontype] && terminalTypeMap[commontype].iconName) {
          bgImg = terminalTypeMap[commontype].iconName;
        } else {
          bgImg = `unkown${onlineStatus}`;
        }

        break;
      }
    }
    return bgImg;
  },
  /****
   * 递归统计拓扑中不在store中存在的面板布局的设备型号
   * @param {*} renderData  拓扑数据
   * @param {*} deviceLayouts  store中存在的面板布局
   * @param {*} networkPanelClass  需要重新获取端口面板布局的设备型号列表
   * @param {*} sns  需要重新获取端口面板布局的设备型号列表
   */
  getNetworkDeviceClass(renderData, deviceLayouts, networkPanelClass, sns) {
    let deviceType = renderData.deviceType;
    let productClass = renderData.productClass || '';
    console.log('端口布局', deviceLayouts[productClass]);
    if (['SWITCH', 'GATEWAY', 'WR', 'FIREWALL'].indexOf(this.DEVICETYPE[deviceType]) > -1) {
      if (networkPanelClass.indexOf(productClass) == -1 && deviceLayouts[productClass] == undefined) {
        networkPanelClass.push(productClass);
      }
      sns.push(renderData.deviceSn);
    }

    if (renderData.children || renderData._children) {
      let children = renderData.children || renderData._children;
      for (let i = 0; i < children.length; i++) {
        this.getNetworkDeviceClass(children[i], deviceLayouts, networkPanelClass, sns);
      }
    }
  },
  /**
   * 设置拓扑节点的样式
   * 传入sn列表 按class或者id查找修订样式
   * @param {*} deviceSnList  传入的是设备的sn列表，根据id查找节点
   * @param {*} nodeClass 修订节点或者连接线的样式
   * @param {*} type 默认不传的话 修订id的class,如果传入ALL 那么sn对应的上连线也会修订
   *
   */
  setNodeClass(deviceSnList, nodeClass, type) {
    for (let i = 0; i < deviceSnList.length; i++) {
      let sn = deviceSnList[i].replaceAll('.', '');
      let nodeId = null;
      nodeId = '#node_' + sn;
      d3.selectAll(nodeId).classed(nodeClass, true);
      if (type && type == 'ALL') {
        nodeId = '.ls_' + sn;
        d3.selectAll(nodeId).classed(nodeClass, true);
      }
    }
  },

  //根据设备类型，返回大类
  getDeviceMajorType(type) {
    const typeObj = {
      GATEWAY: 'GATEWAY',
      EGW: 'GATEWAY',
      EWR: 'GATEWAY',
      EHR: 'GATEWAY',
      SWITCH: 'SWITCH',
      NBS: 'SWITCH',
      MSW: 'SWITCH',
      ESW: 'SWITCH',
      VIRTUAL: 'SWITCH', //未知设备补齐的网管交换机
      AP: 'AP',
      RAP: 'AP',
      EAP: 'AP',
      AC: 'AC',
      EAC: 'AC',
      FIREWALL: 'FIREWALL'
    };
    return typeObj[type];
  },
  //合并相同型号的末尾
  combineDevice(topoData, topoExpand = 0) {
    if (!topoData) return;
    if (!topoData.children || topoData.children.length == 0) return;
    const noChildNodeMap = {}; //没有子节点的设备
    const hasChildNodes = []; //有子节点的设备
    topoData.children.forEach(item => {
      if (item.children) {
        hasChildNodes.push(item);
      } else {
        const { prodName } = item;
        if (noChildNodeMap[prodName]) {
          noChildNodeMap[prodName]._children.push(item);
        } else {
          noChildNodeMap[prodName] = {
            ...item,
            _children: [item]
          };
        }
      }
    });

    Object.keys(noChildNodeMap).forEach(item => {
      //没有同型号的，移除_children
      if (noChildNodeMap[item]._children && noChildNodeMap[item]._children.length == 1) {
        delete noChildNodeMap[item]._children;
      }
    });
    let children = [];
    if (topoExpand == 1) {
      //不聚合末尾(无子节点)同型号节点
      const arr = [];
      Object.values(noChildNodeMap).forEach(item => {
        const { _children } = item;
        if (_children) {
          _children.forEach(it => {
            arr.push({ ...it, spreadFlag: true });
          });
        } else {
          arr.push({ ...item, spreadFlag: true });
        }
      });
      children = [...arr, ...hasChildNodes];
    } else {
      //聚合末尾(无子节点)同型号
      children = [...Object.values(noChildNodeMap), ...hasChildNodes];
    }

    topoData.children = sortBy(children, ['prodName']);
    topoData.children.forEach(item => {
      this.combineDevice(item, topoExpand);
    });
  }
};

/**
 * 判断当前口是否生效
 * @param {*} portMediumType
 * @param {*} localMediumType
 */
const checkMultiplexing = function (portMediumType, localMediumType) {
  //判断接口数据是否存在MediumType
  if (portMediumType) {
    //如果接口数据是分光模式或者本地是sc光口，那么就不是光电复用
    if (
      //localMediumType.toLocaleLowerCase() == 'Fiber'.toLocaleLowerCase() ||
      portMediumType.toLocaleLowerCase() == 'fiberBranch'.toLocaleLowerCase()
    ) {
      return true;
    }
    return portMediumType.toLocaleLowerCase() == localMediumType.toLocaleLowerCase();
  } else {
    return true;
  }
};

/**
 * 获取交换机order
 * @param {*} item
 * @returns
 */
const getSwitchOrder = function (item) {
  return item.orderAlias || item.order;
};

//获取图片宽高,和base64url
const getImageSize = function (url) {
  return new Promise(function (resolve) {
    let image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = url;
    image.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = image.width * 2; //*2 为了提高清晰度
      canvas.height = image.height * 2;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, image.width * 2, image.height * 2);
      const dataURL = canvas.toDataURL('image/png');
      resolve({
        width: image.width,
        height: image.height,
        url,
        base64: dataURL
      });
    };
    image.onerror = function () {
      const canvas = document.createElement('canvas');
      canvas.width = image.width * 2; //*2 为了提高清晰度
      canvas.height = image.height * 2;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, image.width * 2, image.height * 2);
      const dataURL = canvas.toDataURL('image/png');
      resolve({
        width: image.width,
        height: image.height,
        url: '//smb.cdn/materialMini/brand/no_prod_sd.png',
        base64: dataURL
      });
    };
  });
};

export { topoTools, checkMultiplexing, getSwitchOrder, getImageSize };
